import { ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import colorConfigs from "../../configs/colorConfigs";
import { RootState } from "../../redux/store";
import { RouteType } from "../../routes/config";

type Props = {
  item: RouteType;
};

const SidebarItem = ({ item }: Props) => {
  const { appState } = useSelector((state: RootState) => state.appState);

  return item.sidebarProps && item.path ? (
    <ListItemButton
    // style={{borderBottom:'1px', borderTop:'0px',borderRight:'0px',borderLeft:'0px', borderStyle:'solid', borderColor:'#ffffff12', paddingBottom:'13px', paddingTop:'13px'}}
      component={Link}
      to={item.path}
      sx={{
        "&: hover": {
          backgroundColor: colorConfigs.sidebar.hoverBg,
        },
        backgroundColor:
          appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
        paddingY: "5px",
        paddingX: "10px",
      }}
    >
      <ListItemIcon
        sx={{
          color: colorConfigs.sidebar.color,
          minWidth: "25px", // Ensures consistent spacing
          "& svg": {
            fontSize: "15px",
            fontFamily:'Open Sans',
            
          },
        }}
      >
        {item.sidebarProps.icon && item.sidebarProps.icon}
      </ListItemIcon>
      <Typography
        sx={{
          fontSize: "13px", // Consistent text size
          color: colorConfigs.sidebar.color,
          fontFamily:'Open Sans' // Consistent icon size

        }}
      >
        {item.sidebarProps.displayText}
      </Typography>
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
